import { render, staticRenderFns } from "./Gongxu.vue?vue&type=template&id=4cb4d95c"
import script from "./Gongxu.vue?vue&type=script&lang=js"
export * from "./Gongxu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports